"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretDown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CaretDown = () => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: (0, jsx_runtime_1.jsx)("polyline", { points: "208 96 128 176 48 96", fill: "none", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" }) })));
};
exports.CaretDown = CaretDown;
